import { render, staticRenderFns } from "./ChatReportObjectsList.vue?vue&type=template&id=75751684"
import script from "./ChatReportObjectsList.vue?vue&type=script&lang=ts"
export * from "./ChatReportObjectsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports